var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModelYM',{attrs:{"ym":_vm.ymd,"disabled":_vm.disabled,"label":_vm.label},on:{"change":_vm.emit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }